import { render } from "./withdraw-us.vue?vue&type=template&id=d9c55e64&scoped=true"
import script from "./withdraw-us.vue?vue&type=script&lang=js"
export * from "./withdraw-us.vue?vue&type=script&lang=js"

import "./withdraw-us.vue?vue&type=style&index=0&id=d9c55e64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9c55e64"]])

export default __exports__